import React from 'react';
import { motion } from 'framer-motion';
import { Videocam, People, Schedule, YouTube } from '@mui/icons-material';

const stats = [
  { number: '3,000+', label: 'Hours of content filmed', Icon: Videocam },
  { number: '50+', label: 'Happy clients', Icon: People },
  { number: '9', label: "Years' experience", Icon: Schedule },
  { number: '150+', label: 'Videos on YouTube', Icon: YouTube }
];

const PortfolioStats: React.FC = () => {
  return (
    <section className="py-24 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {stats.map((stat, index) => {
            const Icon = stat.Icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="relative rounded-xl border border-gray-800 bg-gray-900/50 p-8 text-center hover:border-bizani-orange/50 hover:bg-gray-900/80 transition-all duration-300 group"
              >
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-12 h-0.5 bg-bizani-orange rounded-full opacity-80 group-hover:opacity-100 transition-opacity" />
                <div className="flex justify-center mb-4">
                  <div className="w-14 h-14 rounded-full bg-bizani-orange/20 flex items-center justify-center group-hover:bg-bizani-orange/30 transition-colors">
                    <Icon style={{ fontSize: 28, color: '#EF3F23' }} />
                  </div>
                </div>
                <div
                  className="text-4xl sm:text-5xl font-headline font-bold mb-2 tracking-tight"
                  style={{ color: '#EF3F23' }}
                >
                  {stat.number}
                </div>
                <div className="text-gray-400 font-body text-sm sm:text-base leading-snug">
                  {stat.label}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PortfolioStats;
